<template>
	<div class="swiper-container" :class="`swiper-container-${id}`">
		<div class="swiper-wrapper">
			<div
				v-for="file in files"
				:key="file"
				:data-file="file"
				class="swiper-slide"
			>
				<img v-if="isImage(file)" :src="require(`@/assets/projects/${file}`)" />
				<video
					v-else
					class="video"
					autoplay
					muted
					loop
					:src="require(`@/assets/projects/${file}`)"
				></video>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from 'swiper'
import { mapGetters } from 'vuex'

export default {
	data: () => {
		return {
			slider: null
		}
	},
	props: ['id', 'files', 'reverseDirection'],
	mounted () {
		const vm = this

		const sliderContainer = document.querySelector(
			`.swiper-container-${this.id}`
		)

		this.slider = new Swiper(sliderContainer, {
			speed: this.config.sliderSpeed,
			direction: 'vertical',
			slidesPerView: 'auto',
			loop: true,
			preloadImages: true,
			updateOnImagesReady: true,
			init: false,
			threshold: this.config.sliderTreshold,
			preventClicks: true,
			preventClicksPropagation: true,
			updateOnWindowResize: false,
			on: {
				init: function () {
					vm.$store.dispatch('addSlider', this)
				},
				click: () => {
					vm.openGalery()
				}
			}
		})

		this.slider.on('init', () => {
			this.slider.on('imagesReady', () => {
				vm.slider.slideToLoop(0)
			})

			const videos = sliderContainer.querySelectorAll('video')
			videos.forEach(video => {
				video.addEventListener('loadeddata', () => {
					vm.slider.update()
					vm.slider.slideToLoop(0)
				})
			})
		})

		this.slider.init()

		this.slider.on('slideChangeTransitionEnd', () => {
			// console.log(this.slider.realIndex)
		})
	},
	methods: {
		isImage (file) {
			const fileExtension = file.split('.').pop()
			return !!(fileExtension === 'jpg' || fileExtension === 'png')
		},
		openGalery () {
			this.$store.dispatch('stopAutoplay')
			this.$store.dispatch('openGalery', this.slider.clickedSlide.dataset.file)
		}
	},
	computed: {
		...mapGetters(['config', 'countdownEnded'])
	},
	watch: {
		countdownEnded (newValue, oldValue) {
			if (newValue) {
				this.slider.params.autoplay = {
					delay: this.config.sliderAutoplayDelay,
					disableOnInteraction: false,
					reverseDirection: this.reverseDirection
				}
				this.slider.autoplay.start()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "~swiper/swiper";

img,
video {
	width: 100%;
	display: block;
}

.swiper {
	&-container {
		background: white;
		width: 100%;
		height: 100vh;
	}
	&-wrapper {
		width: 100%;
	}
	&-slide {
		background: white;
		width: 100%;
		height: auto !important;
		max-height: 100vh;

		&:hover {
			opacity: 0.8;
		}
	}
}
</style>
